/** Styrelse (board) access — separate from admin settings permissions. */

export function userIsBoardMember(user) {
  if (!user) return false;
  return user.isBoardMember === true || user.is_board_member === true;
}

export function userCanAccessBoardPage(userInfo) {
  if (!userInfo || !Array.isArray(userInfo) || !userInfo[0]) return false;
  const user = userInfo[0];
  return user.isAdmin === true || userIsBoardMember(user);
}
